import { render, staticRenderFns } from "./personal_page.vue?vue&type=template&id=f6065086&scoped=true"
import script from "./personal_page.vue?vue&type=script&lang=js"
export * from "./personal_page.vue?vue&type=script&lang=js"
import style0 from "./personal_page.vue?vue&type=style&index=0&id=f6065086&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6065086",
  null
  
)

export default component.exports